import { render, staticRenderFns } from "./CheckboxMagazine.vue?vue&type=template&id=192e05d3&"
import script from "./CheckboxMagazine.vue?vue&type=script&lang=js&"
export * from "./CheckboxMagazine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports